import { Status } from '@tmov/design-system';
import React from 'react';

import StatusDemandaEnum from '../../../Enum/StatusDemandaEnum';

export const getDemandaStatusWidget = demandaStatus => {
  if (demandaStatus === StatusDemandaEnum.CARREGANDO) {
    return (
      <Status
        label={StatusDemandaEnum.getTipo(StatusDemandaEnum.CARREGANDO).label}
        variant="success"
      />
    );
  }
  if (demandaStatus === StatusDemandaEnum.SUSPENSO) {
    return (
      <Status
        label={StatusDemandaEnum.getTipo(StatusDemandaEnum.SUSPENSO).label}
        variant="error"
      />
    );
  }
  return (
    <Status
      label={StatusDemandaEnum.getTipo(StatusDemandaEnum.FINALIZADO).label}
      variant="inactive"
    />
  );
};
